<template>
  <div class="folders-listing">
    <div class="flex justify-end">
      <vs-button color="dark" type="flat" icon-pack="feather" icon="icon-arrow-left" class="p-3 bg-primary"
        @click="goBack()">Back</vs-button>
    </div>
    <vx-card title="Project Files" class="lead-listing">
      <vs-tabs alignment="fixed">
        <!-- Reports Tab -->
        <vs-tab :label="$t('labels.report')">
          <div class="mt-4">
            <div class="vx-row w-full m-0 list-header">
              <div class="vx-col w-1/2 mb-4 set_limit pl-0 pr-0 justify-between">
                <div class="set flex">
                  <label class="limit_label">{{ $t("labels.show") }}</label>
                  <v-select v-model="limit" :options="limitarr" :reduce="(limitarr) => limitarr.value"
                    :clearable="false" label="text" class="px-1" />
                  <label class="limit_label">{{ $t("labels.report") }}</label>
                </div>
              </div>
              <div class="vx-col w-1/2 pl-0 pr-0 justify-flex-end addbtn-col mb-0">
                <vs-button v-if="!isUserType('CL')" color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                  class="float-right btn-add" @click="openAddReport()">
                  {{ $t("labels.add_report") }}
                </vs-button> 
              </div>
            </div>

            <vs-table :data="reports" class="permission">
              <template slot="thead">
                <vs-th class="col-md-4">{{ $t("labels.report") }}</vs-th>
                <vs-th class="col-md-2">{{ $t("labels.date") }}</vs-th>
                <vs-th class="col-md-3">{{ $t("labels.action") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ tr.name }}</vs-td>
                  <vs-td>{{ tr.created_at | only_date_format }}</vs-td>
                  <vs-td>
                    <div class="flex">
                      <vs-button v-if="!isPdf(tr.report_url)" type="flat" icon-pack="feather" icon="icon-download"
                        color="dark" @click="openViewFile(tr.report_url)"></vs-button>
                      <vs-button v-else type="flat" icon-pack="feather" icon="icon-eye" color="dark"
                        @click="openViewFile(tr.report_url)"></vs-button>
                      <vs-button v-if="checkPermission('project', 'delete')" type="flat" icon-pack="feather"
                        icon="icon-trash-2" color="danger" @click="deleteConfirm(tr.id, 'report')"></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <div class="mt-6">
              <vs-pagination color="dark" :total="totalPage" v-model="currentx" class="mb-1"></vs-pagination>
            </div>
          </div>
        </vs-tab>

        <!-- Documents Tab -->
        <vs-tab :label="$t('labels.document')">
          <div class="mt-4">
            <div class="vx-row w-full m-0 list-header">
              <div class="vx-col w-1/2 mb-4 set_limit pl-0 pr-0 justify-between">
                <div class="set flex">
                  <label class="limit_label">{{ $t("labels.show") }}</label>
                  <v-select v-model="limit" :options="limitarr" :reduce="(limitarr) => limitarr.value"
                    :clearable="false" label="text" class="px-1" />
                  <label class="limit_label">{{ $t("labels.document") }}</label>
                </div>
              </div>
              <div class="vx-col w-1/2 pl-0 pr-0 justify-flex-end addbtn-col mb-0">
                <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                  class="float-right btn-add" v-if="!isUserType('CL')" @click="openAddDocument()">
                  {{ $t("labels.add_document") }}
                </vs-button>
              </div>
            </div>

            <vs-table :data="documents" class="permission">
              <template slot="thead">
                <vs-th class="col-md-4">{{ $t("labels.document") }}</vs-th>
                <vs-th class="col-md-2">{{ $t("labels.date") }}</vs-th>
                <vs-th class="col-md-3">{{ $t("labels.action") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ tr.name }}</vs-td>
                  <vs-td>{{ tr.created_at | only_date_format }}</vs-td>
                  <vs-td>
                    <div class="flex">
                      <vs-button v-if="!isPdf(tr.document_url)" type="flat" icon-pack="feather" icon="icon-download"
                        color="dark" @click="openViewFile(tr.document_url)"></vs-button>
                      <vs-button v-else type="flat" icon-pack="feather" icon="icon-eye" color="dark"
                        @click="openViewFile(tr.document_url)"></vs-button>
                      <vs-button v-if="checkPermission('project', 'delete')" type="flat" icon-pack="feather"
                        icon="icon-trash-2" color="danger" @click="deleteConfirm(tr.id, 'document')"></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>

    <!-- Upload Popup -->
    <vs-popup v-if="addPopup.isShow" :title="addPopup.title" class="another-popup" :active.sync="addPopup.isShow">
      <div class="vx-row w-full m-0 mb-4">
        <div class="vx-col w-full mb-4 pl-0">
          <label>{{ addPopup.message }}</label>
          <FilePicker ref="filePicker" :acceptFormat="acceptedFormats" :isMultiple="true"
            :maxFileSize="100 * 1024 * 1024" />
        </div>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button type="border" @click="popupCallback(false)">
          {{ addPopup.buttons[0] }}
        </vs-button>
        <vs-button class="ml-5" id="uploadBtn" @click="popupCallback(true)">
          {{ addPopup.buttons[1] }}
        </vs-button>
      </div>
    </vs-popup>

    <!-- UpdateStatus Popup -->
    <vs-popup class="holamundo" :title="$t('labels.update_status')" :active.sync="popupActive">
      <p class="mb-4">{{ $t("strings.update_status") }}</p>
      <ul class="centerx">
        <li>
          <vs-radio v-model="user_status" vs-value="DR">{{ $t("labels.draft") }}</vs-radio>
        </li>
        <li>
          <vs-radio v-model="user_status" vs-value="SC">{{ $t("labels.sent_to_client") }}</vs-radio>
        </li>
      </ul>
      <vs-button class="mt-4 vs-button-primary" :disabled="button_loading" @click.prevent="updateStatus()"
        id="update-status">{{ $t("labels.update_status") }}</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import FilePicker from "@/components/file-picker.vue";
export default {
  components: { FilePicker },
  data() {
    return {
      reports: [],
      documents: [],
      currentx: 1,
      totalPage: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      limitarr: [
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
      ],
      addPopup: {
        isShow: false,
        title: "",
        message: "",
        buttons: ["Cancel", "Upload"],
        type: "report", // or "document"
      },
      selectedItem: null,
      popupActive: false,
      user_status: null,
      deleteId: null,
      deleteType: null,
      button_loading: false,
    };
  },
  computed: {
    project_id() {
      return this.$route.params.project_id;
    },
    acceptedFormats() {
      return this.addPopup.type === "document"
        ? [".pdf", ".csv", ".xls", ".xlsx", ".png", ".docx", ".zip"]
        : [".pdf", ".csv", ".xls", ".xlsx", ".png", ".docx"];
    },
  },
  watch: {
    limit() {
      this.getAll();
    },
    currentx() {
      this.getAll();
    },
  },
  methods: {
    goBack() {
      this.$router.push("/projects");
    },
    async getAll() {
      const id = this.project_id;
      if (!id) return;

      let input = {
        page: this.currentx,
        perPage: this.limit,
      };

      const [reportRes, docRes] = await Promise.all([
        this.getHTTPPostResponse(`/projects/${id}/report/list`, input),
        this.getHTTPPostResponse(`/projects/${id}/document/list`, input),
      ]);

      this.reports =
        reportRes && reportRes.data && reportRes.data && reportRes.data.projectReports
          ? reportRes.data.projectReports
          : [];

      this.documents =
        docRes && docRes.data && docRes.data && docRes.data.projectDocuments
          ? docRes.data.projectDocuments
          : [];

    },

    openAddReport() {
      this.addPopup = {
        isShow: true,
        title: "Add Report",
        message: "Report File",
        buttons: ["Cancel", "Upload"],
        type: "report",
      };
    },
    openAddDocument() {
      this.addPopup = {
        isShow: true,
        title: "Add Document",
        message: "Document File",
        buttons: ["Cancel", "Upload"],
        type: "document",
      };
    },
    async popupCallback(action) {
      if (!action) {
        this.addPopup.isShow = false;
        return;
      }

      const files = this.$refs.filePicker.selectedFiles || [];
      if (!files.length) {
        this.$vs.notify({
          title: "Error.",
          text: "Please choose minimum one file",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formData = new FormData();
      files.forEach((element, index) => {
        formData.append(`${this.addPopup.type}[${index}]`, element.file);
      });

      const res = await this.getHTTPPostResponse(
        `/projects/${this.project_id}/${this.addPopup.type}/add`,
        formData,
        "#uploadBtn",
        true
      );

      if (res.status == 200) {
        this.$vs.notify({
          title: "Success",
          text: `${this.addPopup.type === "report" ? "Report" : "Document"} uploaded successfully`,
          color: "success",
          position: "top-right",
        });
        this.getAll();
      }

      this.addPopup.isShow = false;
    },
    deleteConfirm(id, type) {
      this.deleteId = id;
      this.deleteType = type;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Confirmation",
        text: "Are you sure you want to delete?",
        acceptText: "Yes",
        cancelText: "No",
        accept: this.deleteItem,
      });
    },
    async deleteItem() {
      const url = `projects/${this.project_id}/${this.deleteType}/delete/${this.deleteId}`;
      const res = await this.getHTTPDeleteResponse(url);
      if (res.status == 200) {
        this.$vs.notify({
          title: "Success",
          text: `${this.deleteType} deleted successfully`,
          color: "success",
          position: "top-right",
        });
        this.getAll();
      }
      this.deleteId = null;
    },
    openUpdateStatus(item, type) {
      this.selectedItem = item;
      this.popupActive = true;
      this.user_status = item.status;
      this.selectedItem.type = type;
    },
    async updateStatus() {
      const url = `projects/${this.project_id}/${this.selectedItem.type}/${this.selectedItem.id}/update/status`;
      const res = await this.getHTTPPutResponse(url, { status: this.user_status });
      if (res.status == 200) {
        this.$vs.notify({
          title: "Success",
          text: "Status updated successfully",
          color: "success",
          position: "top-right",
        });
        this.getAll();
      }
      this.popupActive = false;
    },
    openViewFile(url) {
      window.open(url, "_blank");
    },
    isPdf(url) {
      return /\.pdf$/.test(url);
    },
  },
  mounted() {
    this.getAll();
  },
};
</script>

<style scoped>
.w-70 {
  width: 70% !important;
}

.w-30 {
  width: 30% !important;
}
</style>
